import { usePrefs } from "@/context/PrefsContext";
import { inputCls } from "@/components/AuthLayout";

export const PHONE_COUNTRIES = [["+81", "🇯🇵 +81"], ["+62", "🇮🇩 +62"]];

export function PhoneInput({ country, number, onChange, required = false, testid = "phone" }) {
  const { t } = usePrefs();
  return (
    <div>
      <label htmlFor={`${testid}-number`} className="mb-1.5 block text-xs font-medium uppercase tracking-wide text-muted-foreground">{t("whatsapp")}</label>
      <div className="flex gap-2">
        <select data-testid={`${testid}-country`} value={country} onChange={(e) => onChange({ country: e.target.value, number })} className={`${inputCls.replace("w-full", "")} w-[30%] min-w-0 shrink-0 px-2`}>
          {PHONE_COUNTRIES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <input id={`${testid}-number`} data-testid={`${testid}-number`} type="tel" inputMode="numeric" required={required} placeholder={country === "+81" ? "90-1234-5678" : "812-3456-7890"} className={`${inputCls.replace("w-full", "")} w-[70%] min-w-0`} value={number} onChange={(e) => onChange({ country, number: e.target.value })} />
      </div>
      <p className="mt-1 text-[11px] text-muted-foreground">{t("whatsappHint")}</p>
    </div>
  );
}
